import { Box, Container, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import { appImages } from "../../assets";
import Help from "./Help";
import NavBar from "../../components/NavBar";
import Grid from "@mui/material/Grid2";
import Label from "../../components/label";
import InputField from "../../components/InputField";
import GlobalButton from "../../components/button";
import { contactSupportValidation } from "../../utils/validation";
import { contactSupport } from "../../services/userDetailFn";
import AppLoader from "../../components/apploader";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { t } from "i18next";

const ContactSupport = () => {
  const { palette } = useTheme();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    email: "",
    message: "",
  });

  const [inputError, setInputError] = useState({
    email: false,
    isEmailValid: false,
    password: false,
  });

  const handleChangeInputs = (event) => {
    const { name, value } = event.target;
    setInputError((err) => ({
      ...err,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
    }));
    setInputValues((val) => ({ ...val, [name]: value }));
  };

  const handleContact = async () => {
    try {
      const validate = contactSupportValidation(inputValues, setInputError);
      if (validate) return;

      setIsLoading(true);
      const response = await contactSupport(inputValues);
      if (response.data.status === "success") {
        showSnackbar(response.data.message, "success");
        setInputValues({
          email: "",
          message: "",
        });
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <Box>
        <NavBar />
      </Box>
      <Box
        marginTop={{ xs: 5, sm: 8 }}
        height={"100vh"}
        display={"flex"}
        flexDirection={"column"}
        position={"relative"}
        sx={{
          background: palette.gradient.background,
          backgroundImage: `url(https://service-provider-2024.s3.us-east-1.amazonaws.com/uploads/1744141495520_faq-bg.jpg)`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Header /> */}

        <Box
          flexGrow={10}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          position={"relative"}
          flexDirection={"column"}
          zIndex={999}
        >
          <Typography
            variant="heading_pr"
            component={"h1"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            textTransform={"capitalize"}
          >
            {t("contactSupportHead")}.
          </Typography>

          <Container
            maxWidth={"xs"}
            sx={{
              backgroundColor: "text.white",
              padding: 2,
              borderRadius: 2,
              mt: 5,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={12}>
                <Label text={t("emailAddress")} required htmlFor="user-email" />
                <InputField
                  id={"user-email"}
                  required
                  inputError={inputError.email || inputError.isEmailValid}
                  helperText={
                    inputError.email
                      ? t("emailAddRequired")
                      : inputError.isEmailValid
                      ? t("invalidEmailFormat")
                      : null
                  }
                  placeholder={`${t("enter")} ${t("emailAddress")}`}
                  type={"email"}
                  name={"email"}
                  value={inputValues.email}
                  onChange={handleChangeInputs}
                />
              </Grid>
              <Grid size={12}>
                <Label text={t("message")} required htmlFor="message" />
                <InputField
                  id={"message"}
                  required
                  inputError={inputError.message}
                  helperText={inputError.message && t("messageRequired")}
                  placeholder={`${t("enter")} ${t("message")}`}
                  type={"text"}
                  name={"message"}
                  value={inputValues.message}
                  onChange={handleChangeInputs}
                  multiline={true}
                  rows={3}
                />
              </Grid>

              <Grid size={12}>
                <GlobalButton
                  btnText={"submit"}
                  handleClickBtn={handleContact}
                  styleProps={{
                    width: "100%",
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>

        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
          }}
        />
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default ContactSupport;
